export enum TreeNodeKeyType {
  Location = "@Locations",
  Catergory = "@Categories",
  Favourite = "@Favorites",
  MyFavourite = "@MyFavorites",
  MostUsed = "@MostUsed",
  DefaultCategories = "@DefaultCategories",
}
